import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  IconButton,
  SwipeableDrawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Typography,
  Collapse,
} from '@material-ui/core';
import { ExpandMore, ExpandLess, Menu } from '@material-ui/icons';
import { Navigation } from '..';
import { Icons } from '../../atoms';
import { IconLogo } from '../../../assets';

const StyledContainer = styled.div`
  padding: 0 16px;
  display: flex;
  height: 60px;
  justify-content: center;
  background-color: white;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  @media screen and (max-width: 1050px) {
    padding-top: 0;
    padding: 0.25rem 1rem;
    /* justify-content: space-between; */
  }
  @media screen and (max-width: 1440px) {
    max-width: 1440px;
  }
  @media screen and (min-width: 2560px) {
    height: 90px;
    padding: 0px 20rem 0px 20rem;
  }
`;

const StyledWrapConteiner = styled.div`
  flex: 1;
  max-width: 1280px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 1050px) {
    justify-content: space-between;
  }
  @media screen and (max-width: 1440px) {
    max-width: 1440px;
  }
  @media screen and (min-width: 2560px) {
    max-width: 2560px;
  }
`;

const StyledNav = styled.nav`
  height: 100%;
  // flex: 1;
  display: flex;
  align-items: center;
  @media screen and (max-width: 1050px) {
    display: none;
  }
`;

const StyledWrap = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 1050px) {
    display: none;
  }
`;

const StyledWrapBtn = styled.div`
  width: 105px;
  cursor: pointer;
  background-color: black;
  padding: 8px 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
`;

const StyledMenuButton = styled.div`
  @media screen and (min-width: 1050px) {
    display: none;
  }
`;

const useStyles = makeStyles({
  textItem: {
    '& span': {
      fontSize: 14,
    },
  },
  itemSelected: {
    backgroundColor: 'transparent !important',
    color: '#E3232A',
  },
});

const initCollapse = {
  '/tentang-kami': false,
  '/jalan-tol-kami': false,
  '/ruang-berita': false,
};

const useStylesNav = makeStyles((theme) => ({
  logo: {
    width: 200,
    [theme.breakpoints.up(2560)]: {
      width: 300,
    },
  },
}));

const ItemLink = ({ isId, location, row, onClose }: any) => {
  const classes = useStyles();
  return (
    <ListItem
      button
      key={row.title}
      component={Link}
      classes={{
        selected: classes.itemSelected,
      }}
      onClick={() => onClose()}
      to={{
        pathname: row.link,
        state: { title: row.title },
      }}
      selected={
        location.pathname === row.link ||
        location.pathname.includes(row.link !== '/' ? row.link : '//')
      }
    >
      <ListItemText
        className={classes.textItem}
        primary={isId ? row.title : row.titleEn}
      />
    </ListItem>
  );
};

const ListMenu = ({ handleClose, handleCloseState, isId, dataNav }: any) => {
  const location = useLocation();
  const classes = useStyles();
  const [collapseState, setCollapseState] = useState<any>(initCollapse);
  const [collapseAnnState, setCollapseAnnState] = useState<any>(false);

  const handleOpenCollapse = (link: string) => {
    setCollapseState({
      ...initCollapse,
      [link]: !collapseState[link],
    });
  };

  useEffect(() => {
    const secondPathname = `/${location.pathname.split('/')[1]}`;
    setCollapseState({
      ...initCollapse,
      [secondPathname]: true,
    });
  }, [location.pathname]);

  return (
    <div
      style={{ width: 'auto' }}
      role='presentation'
      onClick={handleClose}
      onKeyDown={handleClose}
    >
      <List>
        {dataNav.map((row: any) => {
          if (row.children) {
            return (
              <>
                <ListItem
                  button
                  key={row.title}
                  onClick={() => handleOpenCollapse(row.link)}
                >
                  <ListItemText
                    className={classes.textItem}
                    style={{
                      color:
                        `/${location.pathname.split('/')[1]}` === row.link
                          ? '#e3232a'
                          : '#424244',
                    }}
                    primary={isId ? row.title : row.titleEn}
                  />
                  {collapseState[row.link] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse
                  in={collapseState[row.link]}
                  timeout='auto'
                  unmountOnExit
                >
                  <List component='div' style={{ padding: 0, paddingLeft: 16 }}>
                    {row.children.map((row: any) => {
                      if (row.children) {
                        return (
                          <>
                            <ListItem
                              button
                              key={row.title}
                              onClick={() =>
                                setCollapseAnnState(!collapseAnnState)
                              }
                            >
                              <ListItemText
                                className={classes.textItem}
                                style={{
                                  color:
                                    `/${location.pathname.split('/')[1]}` ===
                                    '/ruang-berita'
                                      ? '#e3232a'
                                      : '#424244',
                                }}
                                primary={isId ? row.title : row.titleEn}
                              />
                              {collapseAnnState ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )}
                            </ListItem>
                            <Collapse
                              in={collapseAnnState}
                              timeout='auto'
                              unmountOnExit
                            >
                              <List
                                component='div'
                                style={{ padding: 0, paddingLeft: 32 }}
                              >
                                {row.children.map((rowAnn: any) => (
                                  <ItemLink
                                    isId={isId}
                                    location={location}
                                    row={rowAnn}
                                    onClose={handleCloseState}
                                  />
                                ))}
                              </List>
                            </Collapse>
                          </>
                        );
                      }
                      return (
                        <ItemLink
                          isId={isId}
                          location={location}
                          row={row}
                          onClose={handleCloseState}
                        />
                      );
                    })}
                  </List>
                </Collapse>
              </>
            );
          }
          return (
            <ItemLink
              isId={isId}
              location={location}
              row={row}
              onClose={handleCloseState}
            />
          );
        })}
      </List>
    </div>
  );
};

const TopBar = ({ dataNav, isId, changeLang }: any) => {
  const classes = useStylesNav();

  const [state, setState] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleOpenLang = (event: React.MouseEvent<HTMLButtonElement> | any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseLang = () => {
    setAnchorEl(null);
  };

  const handleChangLang = (val: string) => {
    changeLang(val);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setState(open);
  };

  return (
    <StyledContainer>
      <StyledWrapConteiner>
        <IconLogo className={classes.logo} />
        {/* Logo */}
        <div style={{ flex: 1 }} />
        <StyledNav>
          <Navigation DataNav={dataNav} isId={isId} />
          <StyledWrap>
            <StyledWrapBtn
              id={id}
              onClick={handleOpenLang}
              aria-describedby={id}
            >
              {isId ? (
                <>
                  <Icons.IconLangId />
                  <Typography style={{ color: '#eeeeee', margin: '0 0.5rem' }}>
                    ID
                  </Typography>
                </>
              ) : (
                <>
                  <Icons.IconLangEn />
                  <Typography style={{ color: '#eeeeee', margin: '0 0.5rem' }}>
                    EN
                  </Typography>
                </>
              )}
              {anchorEl ? (
                <ExpandLess style={{ color: '#FFFFFF' }} />
              ) : (
                <ExpandMore style={{ color: '#FFFFFF' }} />
              )}
            </StyledWrapBtn>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleCloseLang}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <ListItem button onClick={() => handleChangLang('ID')}>
                <ListItemIcon style={{ minWidth: '35px' }}>
                  <Icons.IconLangId />
                </ListItemIcon>
                <ListItemText primary='ID' />
              </ListItem>
              <ListItem button onClick={() => handleChangLang('EN')}>
                <ListItemIcon style={{ minWidth: '35px' }}>
                  <Icons.IconLangEn />
                </ListItemIcon>
                <ListItemText primary='EN' />
              </ListItem>
            </Popover>
          </StyledWrap>
        </StyledNav>
        <div style={{ display: 'flex' }}>
          <StyledMenuButton>
            <IconButton
              onClick={toggleDrawer(true)}
              edge='start'
              color='inherit'
              aria-label='open drawer'
            >
              <Menu style={{ color: '#424244', fontSize: 40 }} />
            </IconButton>
          </StyledMenuButton>
        </div>
        <SwipeableDrawer
          anchor='top'
          open={state}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          <ListMenu
            dataNav={dataNav}
            handleClose={() => toggleDrawer(false)}
            handleCloseState={() => setState(false)}
            isId={isId}
          />
          <div
            style={{
              position: 'absolute',
              top: 8,
              right: 16,
            }}
          >
            <StyledWrapBtn
              id={id}
              onClick={handleOpenLang}
              aria-describedby={id}
            >
              {isId ? (
                <>
                  <Icons.IconLangId />
                  <Typography style={{ color: '#eeeeee', margin: '0 0.5rem' }}>
                    ID
                  </Typography>
                </>
              ) : (
                <>
                  <Icons.IconLangEn />
                  <Typography style={{ color: '#eeeeee', margin: '0 0.5rem' }}>
                    EN
                  </Typography>
                </>
              )}
              {anchorEl ? (
                <ExpandLess style={{ color: '#FFFFFF' }} />
              ) : (
                <ExpandMore style={{ color: '#FFFFFF' }} />
              )}
            </StyledWrapBtn>
          </div>
        </SwipeableDrawer>
      </StyledWrapConteiner>
    </StyledContainer>
  );
};

export default TopBar;
